module.exports = __webpack_public_path__ + "static/media/micro.54ca927b.png";